export default {
  header: '',
  footer: '',
};



// WEBPACK FOOTER //
// ./src/widgets/range-input/defaultTemplates.js